/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Change email
 * @export
 * @interface CompanyChangeEmail
 */
export interface CompanyChangeEmail {
    /**
     * 
     * @type {string}
     * @memberof CompanyChangeEmail
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyChangeEmail
     */
    newEmail?: string;
}

export function CompanyChangeEmailFromJSON(json: any): CompanyChangeEmail {
    return CompanyChangeEmailFromJSONTyped(json, false);
}

export function CompanyChangeEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyChangeEmail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
        'newEmail': !exists(json, 'new_email') ? undefined : json['new_email'],
    };
}

export function CompanyChangeEmailToJSON(value?: CompanyChangeEmail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'new_email': value.newEmail,
    };
}


